import { createSelector } from 'reselect';

const selectEmployees = (state: any) => state.employees;


export const selectEmployeesCurrentItem = createSelector([selectEmployees], (employees) => employees.current);

export const selectEmployeesListItems = createSelector([selectEmployees], (employees) => employees.list);

export const selectEmployeesItemById = (itemId: any) =>
    createSelector(selectEmployeesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEmployeesCreatedItem = createSelector([selectEmployees], (employees) => employees.create);

export const selectEmployeesUpdatedItem = createSelector([selectEmployees], (employees) => employees.update);

export const selectEmployeesReadItem = createSelector([selectEmployees], (employees) => employees.read);

export const selectEmployeesDeletedItem = createSelector([selectEmployees], (employees) => employees.delete);

export const selectEmployeesSearchedItems = createSelector([selectEmployees], (employees) => employees.search);

export const selectEmployeesItemsCount = createSelector([selectEmployees], (employees) => employees.count);

export const selectEmployeesItemsFilter = createSelector([selectEmployees], (employees) => employees.filter);